import { Component, Input, OnInit } from '@angular/core';
import { HttpService } from '../../../../services/http.service';
import { environment } from '../../../../../environments/environment';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.scss'],
})

export class EditProductComponent implements OnInit {
  @Input() type: string;
  urlImages = environment.uriProduct;
  url = environment.url;
  list:any = [];
  defaultImg = environment.defaultImg;

  notData: string;

  constructor(
    private httpSv: HttpService,
    private modalController: ModalController
  ) { }

  async ngOnInit() {
    try{
      // if(this.type === 'products'){
      let fixType = this.type.slice(0, this.type.length - 1);
      this.list = await this.httpSv.itemIndex(fixType);
      
      if(this.type === 'categorys'){
        fixType = 'categorie';
      }
      
      if (!this.list.length){
        this.list = this.list.data;
        if(!this.list.length){
          this.notData = 'UPS. No hay datos creados!';
        }

      }
      this.list.map(x => {
        x.file = x?.file ? `${this.url}/file/${fixType}/${x?.file}` : undefined;
        x.banner = x?.banner ? `${this.url}/file/${fixType}/${x?.banner}` : undefined;
        x.url = x?.url ? `${this.url}/file/${fixType}/${x?.file}` : undefined;
        if(x?.media){
          x?.media?.map(item => {
            item.file = item?.file;
            item.url = `${this.url}/file/${fixType}/${item?.file}`;
          })
        }
      });

        
      // }
      // }else if(this.type === 'catalogues'){
      //   this.list = await this.httpSv.showCatalogueIds();
      //   this.list.map(x => {
      //     x.file = `${this.url}/file/catalogue/${x.file}`;
      //     x.banner = `${this.url}/file/catalogue/${x.banner}`;
      //     x.media.map(item => {
      //       item.file = item.file;
      //       item.url = `${this.url}/file/catalogues/${item.file}`;
      //     })
      //   })
      // }else if(this.type === 'categorys'){
      //   this.list = await this.httpSv.getCategories();
      //   this.list.map(x => {
      //     x.file = `${this.url}/file/categories/${x.file}`;
      //   })
        
      // }
    }catch(err){
      console.error(err);
    }
  }

  action(item?, role?){
    this.modalController.dismiss(item, role);
  }

}
